import { HomeRepairServiceOutlined as HomeRepairServiceOutlinedIcon } from '@mui/icons-material';
import type { SvgIconComponent } from '@mui/icons-material';
import { guaranteesCompactNavigationIcons } from './constants.ts';
import type {
  IBuildGuaranteesNavigationParams,
  IGuaranteesNavigationConfigItem,
  TGuaranteesNavigationItem,
} from './types.ts';

export const buildVisibleNavigationItems = (
  items: readonly IGuaranteesNavigationConfigItem[],
  visibilityMap: IBuildGuaranteesNavigationParams
): TGuaranteesNavigationItem[] =>
  items
    .filter((item) => visibilityMap[item.visibilityKey])
    .map(({ visibilityKey: _visibilityKey, ...item }) => item);

export const isNavigationItemGroup = (
  item: TGuaranteesNavigationItem
): item is TGuaranteesNavigationItem & { children: TGuaranteesNavigationItem[] } =>
  Array.isArray(item.children) && item.children.length > 0;

export const getNavigationItemPath = (
  item: TGuaranteesNavigationItem,
  parentSegment?: string
): string => {
  const fullSegment = parentSegment ? `${parentSegment}/${item.segment}` : item.segment;
  return `/${fullSegment}`;
};

const getComparableNavigationPath = (path: string): string =>
  path.split('?')[0]?.split('#')[0] ?? path;

export const isNavigationItemActive = (
  currentPath: string,
  item: TGuaranteesNavigationItem,
  parentSegment?: string
): boolean => {
  const comparableCurrentPath = getComparableNavigationPath(currentPath);

  if (isNavigationItemGroup(item)) {
    const groupPath = getComparableNavigationPath(getNavigationItemPath(item));
    return comparableCurrentPath === groupPath || comparableCurrentPath.startsWith(`${groupPath}/`);
  }

  const itemPath = getComparableNavigationPath(getNavigationItemPath(item, parentSegment));
  return comparableCurrentPath === itemPath || comparableCurrentPath.startsWith(`${itemPath}/`);
};

export const getCompactNavigationIcon = (item: TGuaranteesNavigationItem): SvgIconComponent =>
  guaranteesCompactNavigationIcons[item.segment] ?? HomeRepairServiceOutlinedIcon;
